import {
  Grid,
  List,
  ListItemButton,
  Button,
  Divider,
  Typography,
  Stack,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ICashBoxDetailWPO, IPurchaseOrder } from "../../common/interfaces";
import { CommonService } from "../../services/CommonService";
import PaymentsIcon from "@mui/icons-material/Payments";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import { useLocalStorage } from "../../auth/useLocalStorage";

interface PaySupplierProps {
  handleCancel: () => void;
}

export const PaySupplier: React.FC<PaySupplierProps> = (props) => {
  const [user] = useLocalStorage("user", null);
  const [step, setStep] = useState("first");
  const [poList, setPoList] = useState<ICashBoxDetailWPO[]>([]);
  const [selectedPO, setSelectedPO] = useState<IPurchaseOrder | undefined>(
    undefined
  );
  useEffect(() => {
    CommonService.getPoToPayInPos(user.cbox.id).then(({ success, object }) => {
      if (success) {
        setPoList(object || []);
      }
    });
  }, []);
  const execute = async () => {
    const {success, object: { amount }} = await CommonService.getAmountCash(user.cbox.id);
    if(success && selectedPO){
      console.log({amount, selectedPO: selectedPO?.grand_total})
      // return;
      const purchaseOrderTotal = Number(selectedPO?.grand_total ?? 0)
      if(amount < purchaseOrderTotal){
        CommonService.toast("No hay fondos suficientes para pagar esta orden", "error");
        return
      }
      CommonService.payPurchaseOrder(selectedPO.id).then(({success}) => {
        if(success){
          CommonService.toast("Orden pagada correctamente", "success");
          CommonService.printTicketPoPayment(selectedPO.id)
          props.handleCancel();
        }
      });
    }
    console.log("execute");
  };
  useEffect(() => {
    console.log(selectedPO);
  }, [selectedPO]);
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} style={{ textAlign: "center" }}>
        {step === "first" && (
          <div>
            <List style={{ width: "100%" }} component="div">
              {poList &&
                poList.map(
                  ({
                    purchase_order: item,
                  }: {
                    purchase_order: IPurchaseOrder;
                  }) => (
                    <div key={item.id} style={{ width: "100%" }}>
                      <ListItemButton
                        onClick={() => {
                          setSelectedPO(item);
                          setStep("second");
                          CommonService.openCashDrawer();
                        }}
                        style={{ width: "100%", flexDirection: "column", alignItems: "flex-start" }}
                      >
                        <div style={{ width: "100%", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                          <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                            <div style={{ fontWeight: "bold", fontSize: "1.1em" }}>OC - {item.id}</div>
                            <div style={{ width: "200px" }}>
                              {item.is_credit === "1" ? (
                                <div style={{ color: "red", display: "flex", alignItems: "center", gap: "5px" }}>
                                  <CreditCardIcon />
                                  CRÉDITO
                                </div>
                              ) : (
                                <div style={{ color: "green", display: "flex", alignItems: "center", gap: "5px" }}>
                                  <PaymentsIcon /> CONTADO
                                </div>
                              )}
                            </div>
                          </div>
                          <div style={{ fontWeight: "bold", fontSize: "1.2em" }}>
                            $ {item.grand_total}
                          </div>
                        </div>
                        <div style={{ width: "100%", display: "flex", fontSize: "0.85em", color: "#ccc", gap: "20px", marginTop: "8px" }}>
                          <div>
                            <strong>Proveedor:</strong> {item.supplier?.nombre || 'N/A'}
                          </div>
                          <div>
                            <strong>Fecha:</strong> {new Date(item.created_at).toLocaleString('es-MX', {
                              year: 'numeric',
                              month: '2-digit',
                              day: '2-digit',
                              hour: '2-digit',
                              minute: '2-digit'
                            })}
                          </div>
                          <div>
                            <strong>Registrado por:</strong> {item.user?.nombre || 'N/A'}
                          </div>
                        </div>
                      </ListItemButton>
                      <Divider />
                    </div>
                  )
                )}
              {poList?.length === 0 && (
                <Typography>
                  No hay ordenes de compra pendientes de Pago
                </Typography>
              )}
            </List>
            <div style={{ marginTop: "30px" }}>
              <Stack
                direction="row"
                spacing={2}
                justifyContent="center"
                alignItems="center"
              >
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => props.handleCancel()}
                >
                  Cancelar
                </Button>
              </Stack>
            </div>
          </div>
        )}
        {step === "second" && selectedPO !== undefined && (
          <div>
            <Typography style={{ fontSize: "24px" }}>
              El pago de la Orden de Compra sera en Efectivo, asegurate de tener
              lo suficiente.
            </Typography>
            <Typography style={{ textAlign: "left" }}>
              <span style={{ fontWeight: "bold" }}>Proveedor: </span>{" "}
              {selectedPO?.supplier?.nombre}
            </Typography>
            <Typography style={{ textAlign: "left" }}>
              <span style={{ fontWeight: "bold" }}>Orden de Compra: </span>{" "}
              {selectedPO.id}
            </Typography>
            <Typography style={{ textAlign: "left" }}>
              <span style={{ fontWeight: "bold" }}>Total: </span>{" "}
              {selectedPO.grand_total}
            </Typography>
            <div style={{ marginTop: "30px" }}>
              <Stack
                direction="row"
                spacing={2}
                justifyContent="center"
                alignItems="center"
              >
                <Button
                  variant="contained"
                  color="error"
                  onClick={() => props.handleCancel()}
                >
                  Cancelar
                </Button>
                <Button
                  variant="contained"
                  size="large"
                  onClick={() => setStep("first")}
                >
                  Atras
                </Button>
                <Button
                  variant="contained"
                  size="large"
                  style={{ marginLeft: "20px" }}
                  onClick={() => execute()}
                >
                  Pagar OC
                </Button>
              </Stack>
            </div>
          </div>
        )}
      </Grid>
    </Grid>
  );
};
